import {Injectable} from '@angular/core';
import { HttpClient } from "@angular/common/http";

import {map, Observable} from "rxjs";

import {BaseHttpService} from "@shared/services-http/base-http.service";

import {GetVehiclesResponse} from './responses/get-vehicles.response';

import {VehicleListItem} from "@handover/view-models/vehicle-list-item";
import {HandoverListItem} from "@handover/view-models/handover-list-item";
import {GetVehicleHandoversResponse} from "@handover/http-services/responses/get-vehicle-handovers.response";
import {GetHandoverResponse} from "@handover/http-services/responses/get-handover.response";
import {GetHandoverResponseMapper} from "@handover/http-services/mappers/get-handover-response-mapper";
import {HandoverModel} from "@handover/view-models/handover.model";
import {GetVehicleResponseMapper} from "@handover/http-services/mappers/get-vehicle-response-mapper";
import {GetVehicleHandoversResponseMapper} from "@handover/http-services/mappers/get-vehicle-handovers-response-mapper";

@Injectable({
  providedIn: 'root'
})
export class HandoverHttpService extends BaseHttpService {

  private readonly getHandoverResponseMapper = new GetHandoverResponseMapper();
  private readonly getVehicleResponseMapper = new GetVehicleResponseMapper();
  private readonly getVehicleHandoversResponseMapper = new GetVehicleHandoversResponseMapper();

  constructor(private httpClient: HttpClient) {
    super();
  }

  getVehicles(vehicleIds: number[]): Observable<VehicleListItem[]> {
    return this.httpClient.post<GetVehiclesResponse[]>(this.getNewApiUrl('/handover/vehicles/gethandoverdriver'), vehicleIds)
      .pipe(map(response => this.getVehicleResponseMapper.mapToVehicleListItem(response)));
  }

  getVehicleHandovers(vehicleId: number): Observable<HandoverListItem[]> {
    return this.httpClient.get<GetVehicleHandoversResponse[]>(this.getNewApiUrl('/handovers/vehicle/') + vehicleId)
      .pipe(map(response => this.getVehicleHandoversResponseMapper.mapToHandoverListItem(response)));
  }

  getStatement(): Observable<string> {
    return this.httpClient.get<string>(this.getNewApiUrl('/globalConfig/worker-statement'));
  }

  setStatement(value: string): Observable<string> {
    return this.httpClient.patch<string>(this.getNewApiUrl('/globalConfig/worker-statement'), {text: value});
  }

  getHandover(handoverId: number, returnId?: number): Observable<HandoverModel> {
    const mapGiven = returnId == null;
    return this.httpClient.get<GetHandoverResponse>(this.getNewApiUrl(`/handovers/${handoverId}`))
      .pipe(map(x => this.getHandoverResponseMapper.mapToHandoverModel(x, mapGiven)));
  }

  getHandoverByToken(token: string): Observable<HandoverModel> {
    return this.httpClient.get<GetHandoverResponse>(this.getNewApiUrl(`/handovers/token/${token}`))
      .pipe(map(x => {
        const isGiven = x.BG.QR === token;
        return this.getHandoverResponseMapper.mapToHandoverModel(x, isGiven);
      }));
  }
}
